/*
 * fn: getBrandSealedLink
 *
 * Gets a search link for a sealed product from a brand
 *
 */
import { type BrandType } from '@/defs/brand'

import { getImpactLink } from './getImpactLink'

type Props = {
  brand: BrandType
  medium?: string
  term: string
}

const CONFIG: Partial<Record<BrandType, (props: Props) => string>> = {
  cardkingdom: ({ medium = 'decklist', term }) => {
    const params = new URLSearchParams({
      'filter[name]': term,
      'filter[tab]': 'product',
      partner: 'edhrec',
      partner_args: `edhrec,${medium}`,
      utm_campaign: 'edhrec',
      utm_medium: medium,
      utm_source: 'edhrec',
    })
    return `https://www.cardkingdom.com/catalog/search?${params.toString()}`
  },
  cardsphere: ({ term }) => {
    const params = new URLSearchParams({
      q: term,
    })

    return `https://www.cardsphere.com/search?${params.toString()}`
  },
  manapool: ({ medium = 'decklist', term }) => {
    const params = new URLSearchParams({
      q: term,
      ref: 'scm',
      ref_meta: `referrer:edhrec,${medium}`,
    })
    return `https://manapool.com/browse_sealed?${params.toString()}`
  },
  scg: ({ term }) =>
    `https://starcitygames.com/search/?sealed_type=Commander%20Decks&search_query=${encodeURIComponent(term).replace(/\+/g, '%20')}&sort=score`,
  tcgplayer: ({ medium = 'decklist', term }) => {
    const params = new URLSearchParams({
      partner: 'EDHREC',
      ProductTypeName: 'Sealed Products',
      q: term,
    })
    return getImpactLink({
      brand: 'tcgplayer',
      subId1: `edhrec,${medium}`,
      u: `https://www.tcgplayer.com/search/all/product?${params.toString()}`,
    })
  },
}

export const getBrandSealedLink = (props: Props) => CONFIG[props.brand]?.(props) || ''
